import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CUSTOMER_OPINIONS_FORM } from '../../constants/paths/api';
import { getCustomerOpinionsDataModel } from '../../helpers/apiHelpers/customerOpinions';
import SuccessOrFailure from '../successOrFailure';
import { customerOpinionsInitialValues, customerOpinionsSchema } from './customerOpinions.schema';
import * as StyledCustomerOpinions from './customerOpinions.styles';
import CustomerOpinionsFormFields from './customerOpinionsFormFields';

interface Props {}

const CustomerOpinions: FC<Props> = () => {
	const { t } = useTranslation('generalForm');

	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [error, setError] = useState(false);

	const onSubmit = values => {
		const model = getCustomerOpinionsDataModel(values);

		axios
			.post(`${CUSTOMER_OPINIONS_FORM}`, model)
			.then(response => {
				setHasSubmitted(true);
				setError(response.data.error);
				window.scrollTo(0, 0);
			})
			.catch(() => {
				setHasSubmitted(true);
				setError(true);
				window.scrollTo(0, 0);
			});
	};

	return (
		<StyledCustomerOpinions.Wrapper>
			{!hasSubmitted && (
				<Formik
					initialValues={customerOpinionsInitialValues}
					enableReinitialize
					validationSchema={customerOpinionsSchema}
					onSubmit={onSubmit}>
					{({ handleSubmit, isSubmitting, values, setFieldTouched, setFieldValue, touched, errors }) => (
						<form onSubmit={handleSubmit}>
							<CustomerOpinionsFormFields
								values={values}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
								isSubmitting={isSubmitting}
								touched={touched}
								errors={errors}
							/>
						</form>
					)}
				</Formik>
			)}
			<SuccessOrFailure hasSubmitted={hasSubmitted} success={!error} messageArray={[t('successMessage')]} />
		</StyledCustomerOpinions.Wrapper>
	);
};

export default CustomerOpinions;
